// extracted by mini-css-extract-plugin
export default {"chartWrap":"SummaryPerformanceChart_chartWrap__V+6OK"};